/************************************
 MODULE:         Store Features
 WHAT IT DOES:   initiate instances of store features list
 *************************************/
 (function (root, factory) {
  if (typeof define === "function" && define.amd) {
    define(["jquery"], factory);
  } else if (typeof exports === "object") {
    module.exports = factory(require("jquery"));
  } else {
    root.returnExports = factory(root.jQuery);
  }
})(this, function ($) {
  function init() {
    var instances = [];
    var $elements = $(".js-store-features:not(.js-sf-inited)");

    if (!$elements.length) {
      return;
    }

    require.ensure(
      [],
      function () {
        var StoreFeatures = require("./store-features");

        $elements.each(function (i, element) {
          instances.push(new StoreFeatures(element));
          element.classList.add("js-sf-inited");
        });
      },
      "store-features"
    );
  }

  return {
    init: init,
  };
});



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/store-features/app.store-features.js
 ** module id = 77
 ** module chunks = 24
 **/